import { Controller } from '@hotwired/stimulus';

export default class extends Controller {

  static targets = ['menu', 'actions', 'message']

  static values = {
    isSelfMessage: Boolean
  }

  enableHover() {
    try {
      this.actionsTarget.classList.remove('hidden');
    } catch (error) {
    }
  }

  disableHover() {
    try {
      const container = document.getElementById('room-message-menu-container');

      if (container.classList.contains('hidden')) {
        this._removeHoverClasses();
      }
    } catch (error) {
    }
  }

  toggle(event) {
    const container = document.getElementById('room-message-menu-container');

    if (this.menuTarget.classList.contains("hidden")) {
      this._showMenuAndContainer(event, container);

    } else {
      this._hideMenuAndContainer(container);
    }
  }

  close() {
    const container = document.getElementById('room-message-menu-container');
    this._hideMenuAndContainer(container);
    this._removeHoverClasses();
  }

  closeWithEscape(event) {
    if (event.keyCode == 27) {
      this.close();
    }
  }

  closeWithClickOutside(event) {
    if (event.srcElement.id === 'room-message-menu-container') {
      this.close();
    }
  }

  _removeHoverClasses() {
    this.actionsTarget.classList.add('hidden');
  }

  _showMenuAndContainer(event, container) {
    // console.log(event.clientX);
    // console.log(window.innerWidth);
    container.classList.remove('hidden');
    container.classList.add('block');
    this.menuTarget.classList.remove('hidden');

    const clientX = event.clientX;
    let innerWidth = window.innerWidth;

    if (this.isSelfMessageValue) {

      if (document.getElementById('room-side-panel-content')) {
        innerWidth = innerWidth - 400;
      }

      const diffX = innerWidth - clientX;

      if (diffX > 300) {
        this.menuTarget.style.right = `${(innerWidth - clientX - 100)}px`;
      } else {
        this.menuTarget.style.right = '40px';
      }
    } else {
      if (clientX > 850) {
        this.menuTarget.style.left = `${clientX - 640}px`;
      } else {
        this.menuTarget.style.left = '100px';
      }
    }

    if (this.isSelfMessageValue) {
      if (window.innerHeight - event.clientY > 410) {
        this.menuTarget.style.top = '30px';
      } else {
        this.menuTarget.style.top = '-289px';
      }
    } else {
      if (window.innerHeight - event.clientY > 315) {
        this.menuTarget.style.top = '30px';
      } else {
        this.menuTarget.style.top = '-200px';
      }
    }
  }

  _hideMenuAndContainer(container) {
    container.classList.add('hidden');
    container.classList.remove('block');
    this.menuTarget.classList.add('hidden');
  }
}